import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../style/contactPage/contactpage.scss";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {
  contact_follow_us_text,
  contact_enquiry_subtitle,
  contact_subnav_content1,
  contact_enquiry_form_submit_btn,
} from "../../utility/constants";
import { UserContext } from "../../use_context";

function ContactEnquiry() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [error, setError] = useState("");
  const [status, setStatus] = useState({ type: null, message: "" });

  // 🟡 NEW: Map iframe from ACF
  // const [mapHtml, setMapHtml] = useState("");
  const { mapHtml, setMapHtml } = useContext(UserContext);
  const [loadingMap, setLoadingMap] = useState(true);

  useEffect(() => {
    if (mapHtml) {
      setLoadingMap(false); // <== This fixes the loader hang issue
      return;
    }
    fetch("https://infoglans.com/search/wp-json/wp/v2/pages/110")
      .then((res) => res.json())
      .then((data) => {
        const iframeHtml = data?.acf?.enquiry?.map_location;
        if (iframeHtml) setMapHtml(iframeHtml);
        setLoadingMap(false);
      })
      .catch(() => {
        setMapHtml("<p>Map not available</p>");
        setLoadingMap(false);
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const validate = () => {
    const { fullName, email, phone, message } = formData;

    if (!fullName.trim()) return setError("Full name is required."), false;
    if (!email.trim()) return setError("Email is required."), false;
    if (!/^\S+@\S+\.\S+$/.test(email))
      return setError("Enter a valid email."), false;
    if (!phone.trim()) return setError("Phone number is required."), false;
    if (!message.trim()) return setError("Message is required."), false;

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const formPayload = new FormData();
    formPayload.append("_wpcf7_unit_tag", "793");
    formPayload.append("your-name", formData.fullName);
    formPayload.append("youremail", formData.email);
    formPayload.append("yourphone", formData.phone);
    formPayload.append("yourmessage", formData.message);

    try {
      const response = await fetch(
        "https://infoglans.com/search/wp-json/contact-form-7/v1/contact-forms/793/feedback",
        {
          method: "POST",
          body: formPayload,
        }
      );

      const result = await response.json();

      if (result.status === "mail_sent") {
        setStatus({
          type: "success",
          message: result.message || "Message sent!",
        });
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        setStatus({
          type: "error",
          message: result.message || "Something went wrong.",
        });
      }
    } catch (err) {
      setStatus({
        type: "error",
        message: "Server error. Please try again later.",
      });
    }
  };

  return (
    <>
      <div>
        <div className="px-0">
          <Row className="contact-enquiry-div d-flex leadership-align contact-padding">
            <Col className="text-black enquiry-form">
              <div>
                <h2>{contact_subnav_content1}</h2>
                <p>{contact_enquiry_subtitle}</p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full name"
                      className="form-fields"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Your email"
                      className="form-fields"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone number"
                      className="form-fields"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Message"
                      rows={3}
                      className="form-fields form-message"
                      required
                    />
                  </Form.Group>

                  {error && <p className="text-danger">{error}</p>}

                  {status.message && (
                    <p
                      className={
                        status.type === "error" ? "text-danger" : "text-success"
                      }
                    >
                      {status.message}
                    </p>
                  )}

                  <Button
                    variant="primary"
                    type="submit"
                    className="form-submit-btn"
                  >
                    {contact_enquiry_form_submit_btn}
                  </Button>
                </Form>
              </div>
            </Col>

            <Col
              lg={6}
              md={12}
              className="text-black contact-map-div justify-content-end align-items-end"
            >
              {loadingMap ? (
                <p>Loading map...</p>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: mapHtml }} />
              )}
            </Col>
          </Row>
        </div>

        <div>
          <hr className="hr-solid-line" />
        </div>
      </div>
    </>
  );
}

export default ContactEnquiry;
